export class Filter {
  isActive: boolean;
  countryIds : number[];
  pageNumber : number;
  pageSize   : number;
  keyword    : string;
  sortDirection:'Asc' |'Desc';
  orderBy : string;
  countryId  : number;
  cityId  : number[]|number;
  areaId  : number;
  variantKeyId  : number;
  variantKeyIds : number[];
  storesIds : number[];
  productsIds : number[];
  categoriesIds : number[];
  categoryIds : number[];
  brandIds : number[];
  BrandIds:number[];
  brandsIds : number[];
  couponIds : number[];
  pointCodeIds : number[];
  hasChildren : boolean;
  usersIds:number[];
  UserIds:number[]
  vendorIds:number[]
  paymentTypeIds:number[]
  streetIds:number[]
  areaIds:number[]
  shippingPereferenceIds:number[]
  UserType:string
  IsConfirmed?:boolean
  onlyParents?:boolean
  CountryCode?:string
  TenantId?:number
  TenantIds?:number[]
  IsFeatured?:boolean
  DeliveredOrderCount?:number
  isHandmade?:boolean
  IsCosmetics?:boolean
  constructor() {
    this.isActive = null;
    this.hasChildren = null;
    this.countryIds =[];
    this.pageNumber =1;
    this.pageSize = 10;
    this.keyword = '';
    this.orderBy ='';
    this.sortDirection = 'Desc';
    this.countryId =null
    this.cityId =null
    this.areaId =null
    this.variantKeyId =null
    this.storesIds =[];
    this.productsIds=[];
    this.categoriesIds=[];
    this.categoryIds=[];
    this.brandsIds=[];
    this.BrandIds=[];
    this.brandIds=[];
    this.couponIds=[];
    this.vendorIds=[]
    this.pointCodeIds=[];
    this.variantKeyIds=[];
    this.usersIds=[]
    this.areaIds=[]
    this.streetIds=[]
    this.shippingPereferenceIds=[]
    this.paymentTypeIds=[]
    this.UserType==null
    this.CountryCode=''
    this.TenantId=null
    this.DeliveredOrderCount=null,
    this.isHandmade=null,
    this.IsFeatured=null,
    this.IsCosmetics=null


  }
  public prepareFilter(){
    this.isActive==null ? delete this.isActive : null;
    this.hasChildren==null ? delete this.hasChildren : null;
    this.onlyParents==null ? delete this.onlyParents : null;
    this.countryIds?.length==0 ? delete this.countryIds : null;
    !this.keyword ? delete this.keyword : null;
    !this.countryId ? delete this.countryId : null;
    !this.cityId ? delete this.cityId : null;
    !this.areaId ? delete this.areaId : null;
    !this.variantKeyId ? delete this.variantKeyId : null;
    !this.UserType ? delete this.UserType : null;
    !this.TenantId ? delete this.TenantId : null;
    !this.DeliveredOrderCount? delete this.DeliveredOrderCount :null
    !this.isHandmade? delete this.isHandmade :null
    !this.CountryCode? delete this.CountryCode :null
    this.IsCosmetics==null ? delete this.IsCosmetics : null
    !this.IsFeatured? delete this.IsFeatured :null

  }
}
